import React from "react";
import { Button } from "semantic-ui-react";
import { WidgetProps } from "../types";
import Prompt from "../Prompt";
import PillPicker from "../PillPicker";
import Summary, { SummaryField, SummaryPills, Actions } from "../Summary";

/**
 * "What is reconstruction?" — choose 15–20 words from everything written
 * earlier in the course.
 */
const MINIMUM_WORDS = 15;
const MAXIMUM_WORDS = 20;

const WordsThatMatter: React.FC<WidgetProps> = ({
  payload,
  update,
  submit,
  submitting,
  finished,
  question,
  currentUser,
}) => {
  const words: string[] = payload.words || [];

  const setWords = (next: string[]) => {
    if (next.length > MAXIMUM_WORDS) return;
    update({ ...payload, words: next });
  };

  const complete = words.length >= MINIMUM_WORDS;

  if (finished) {
    return (
      <Summary question={question} currentUser={currentUser}>
        <SummaryField label="The words that matter most to me">
          <SummaryPills values={words} />
        </SummaryField>
      </Summary>
    );
  }

  return (
    <div className="ui form assignment-form">
      <Prompt question={question} currentUser={currentUser} />

      <div className="ix-section">
        <PillPicker
          selected={words}
          options={payload.word_options || []}
          onChange={setWords}
          placeholder="Add a word of your own"
        />
        <p className="ix-hint">
          {words.length} of {MINIMUM_WORDS}–{MAXIMUM_WORDS} chosen
        </p>
      </div>

      <Actions>
        <Button
          primary
          circular
          className="challenge-submit"
          disabled={!complete || submitting}
          loading={submitting}
          onClick={submit}
        >
          Submit
        </Button>
      </Actions>
    </div>
  );
};

export default WordsThatMatter;
